import {
  BusinessCenter,
  Headset,
  Monitor,
  LocalOffer,
  Bolt,
  PersonAdd,
  ManageSearch,
  Edit,
} from "@mui/icons-material";

/** Home page: five rating dimensions (icons + i18n keys). */
export const HOME_RATING_CATEGORY_ITEMS = [
  { icon: <BusinessCenter />, labelKey: "ratings.services" },
  { icon: <Headset />, labelKey: "ratings.support" },
  { icon: <Monitor />, labelKey: "ratings.website" },
  { icon: <LocalOffer />, labelKey: "ratings.pricing" },
  { icon: <Bolt />, labelKey: "ratings.performance" },
] as const;

/** Home page: "How it works" steps. */
export const HOME_HOW_IT_WORKS_STEPS = [
  {
    icon: <PersonAdd sx={{ fontSize: 32 }} />,
    titleKey: "home.step1Title",
    descKey: "home.step1Description",
  },
  {
    icon: <ManageSearch sx={{ fontSize: 32 }} />,
    titleKey: "home.step2Title",
    descKey: "home.step2Description",
  },
  {
    icon: <Edit sx={{ fontSize: 32 }} />,
    titleKey: "home.step3Title",
    descKey: "home.step3Description",
  },
] as const;
